import { render, staticRenderFns } from "./page-not-found-view.vue?vue&type=template&id=1ee23c1e&scoped=true&"
var script = {}
import style0 from "./page-not-found-view.vue?vue&type=style&index=0&id=1ee23c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee23c1e",
  null
  
)

export default component.exports